import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import QueryState from '../../components/query_state'
import Asset from '../../components/asset'
import AssetsByType from '../../components/assets_table'

const Ads = () => {
  const params = useParams()
  const { data: cycle, isLoading, error } = useQuery(['cycles/', params.cycleID])

  // If we have an assetID param, show the Asset component
  if (params.assetID) {
    return (
      <QueryState isLoading={isLoading} error={error}>
        <Asset
          cycle={cycle}
          listPath={`/airlines/${params.airlineID}/cycles/${params.cycleID}/ads/clips`}
          listLabel='Clips'
        />
      </QueryState>
    )
  }

  // Otherwise show the assets list
  return (
    <QueryState isLoading={isLoading} error={error}>
      <AssetsByType cycle={cycle} assetType={{ value: 'ad', label: 'Clip', plural_label: 'Clips' }} />
    </QueryState>
  )
}

export default Ads
